import { useCallback, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useActiveConversation } from '../../contexts/ActiveConversationContext';
import { IconSend, IconStop } from '../primitives/Icons';

export function Composer() {
  const { t } = useTranslation();
  const { runState, send, stop } = useActiveConversation();
  const [value, setValue] = useState('');
  const taRef = useRef<HTMLTextAreaElement>(null);

  const isStreaming = runState === 'streaming' || runState === 'sending';
  const canSend = value.trim().length > 0 && !isStreaming;

  const autoResize = () => {
    const ta = taRef.current;
    if (!ta) return;
    ta.style.height = '';
    ta.style.height = `${Math.min(ta.scrollHeight, 110)}px`;
  };

  const handleSend = useCallback(() => {
    if (!canSend) return;
    const text = value;
    setValue('');
    if (taRef.current) taRef.current.style.height = '';
    void send(text);
  }, [canSend, send, value]);

  const handleKey = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="chat-input-area">
      <div className="input-wrapper">
        <textarea
          ref={taRef}
          rows={1}
          placeholder={t('inputPlaceholder')}
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            autoResize();
          }}
          onKeyDown={handleKey}
        />
        {isStreaming ? (
          <button
            type="button"
            className="send-btn stop"
            onClick={stop}
            title={t('stop')}
            aria-label={t('stop')}
          >
            <IconStop />
          </button>
        ) : (
          <button
            type="button"
            className="send-btn"
            onClick={handleSend}
            disabled={!canSend}
            aria-label={t('inputPlaceholder')}
          >
            <IconSend />
          </button>
        )}
      </div>
      <div className="input-hint">{t('enterHint')}</div>
    </div>
  );
}
